import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";



export const sendSharingCenter = (data , method ,SendSMS) => http({
    url: ENDPOINTS.SharingCenterApi.SharingCenter.browse,
    method: method,
    data:data,
    params:{
        notify:SendSMS
    }
}).then(response => response.data)
    .catch(err => {
        return Promise.reject(err);
    })
export const deleteBord = (id) => http({
    url: ENDPOINTS.SharingCenterApi.SharingCenter.browse,
    method: "DELETE",
    params:{
        Id:id
    }
}).then(response => response.data)

.catch(err => {
        return Promise.reject(err);
    })


export const getSharingCenterId = (id) => http({
    url: ENDPOINTS.SharingCenterApi.SharingCenter.id,
    method: "get",
    headers: { "Accept-Language": "en" },
    params:{
        Id:id,
    }

}).then(response => response.data)
 .catch(err => {
     return Promise.reject(err);
 })
export const getSharingCenterList = (pageNumber , pageSize, orderFormat: string = "", searchString?: any, filterlist?: any) => http({
    url: ENDPOINTS.SharingCenterApi.SharingCenter.load,
    method: "get",
    params:{
        PageNumber:pageNumber,
        PageSize:pageSize,
        OrderByString: orderFormat,
        SearchString: searchString,
        FilterString: filterlist
    }

}).then(response => response.data)
 .catch(err => {
     return Promise.reject(err);
 })

export const updateBordEndDate = (id , endDate) => http({
    url: ENDPOINTS.SharingCenterApi.SharingCenter.endDate,
    method: "put",
   // headers: { "Accept-Language": "en" },
    params:{
        SharingCenterId: id ,
        endDate:endDate
    }

}).then(response => response.data)
 .catch(err => {
     return Promise.reject(err);
 })

export const sendBordAccess = (data , id) => http({
    url: ENDPOINTS.SharingCenterApi.SharingCenter.access,
    method: "put",
    data:data,
    params:{
        SharingCenterId:id
    }

}).then(response => response.data)
 .catch(err => {
     return Promise.reject(err);
 })
export const getBordAccess = (SharingCenterId) => http({
    url: ENDPOINTS.SharingCenterApi.SharingCenter.access,
    method: "get",
    params:{
        SharingCenterId:SharingCenterId
    }

}).then(response => response.data)
 .catch(err => {
     return Promise.reject(err);
 })


 //----------------------ACCESS---------------------
 
export const  getGroupPositionList =( async ( searchString) =>  await http({
    url: ENDPOINTS.BaseInformation.groupPosition.dictionary,
    method: "get",
    params:{
        SearchString : searchString
    }

    

})
.then((response) => (response.data)) 
.catch(err => {
    return Promise.reject(err);
})
)

export const  getPositionList =( async (searchString ) =>  await http({
    url: ENDPOINTS.BaseInformation.position.browse,
    method: "get",
    params : {
        searchString : searchString
    }

    

})
.then((response) => (response.data)) 
.catch(err => {
    return Promise.reject(err);
})
)


